import SideBar from './side-bar';
import SideBarItem from './item';
import './styles/index.scss';
const ExpandedSideBar = SideBar;
ExpandedSideBar.Item = SideBarItem;
export default ExpandedSideBar;
